import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  blockOfBusiness: {
    key: 'all',
    value: 'All Block of Business',
    disabled: false,
    visible: true,
  },
  employer: {
    key: 'all',
    value: 'All Employers',
    disabled: false,
    visible: true,
  },
  location: {
    key: 'all',
    value: 'All Locations',
    disabled: false,
    visible: true,
  },
};

export const breadCrumbSlice = createSlice({
  name: 'breadCrumb',
  initialState: INITIAL_STATE,
  reducers: {
    setBreadCrumb: (state, action) => {
      const breadCrumbType = action.payload.breadCrumbType;
      const breadCrumbValue = action.payload.breadCrumbValue;
      state[breadCrumbType] = { ...state[breadCrumbType], ...breadCrumbValue };
      if (
        breadCrumbType === 'employer' &&
        state.blockOfBusiness.key === 'all'
      ) {
        if (
          breadCrumbValue.blockOfBusinessKey &&
          breadCrumbValue.blockOfBusinessName
        ) {
          state.blockOfBusiness.key = breadCrumbValue.blockOfBusinessKey;
          state.blockOfBusiness.value = breadCrumbValue.blockOfBusinessName;
        }
      }
    },
    resetBreadCrumb: (state, action) => {
      const breadCrumbType = action.payload?.breadCrumbType;
      if (!action.payload || breadCrumbType === 'all') {
        state.blockOfBusiness = INITIAL_STATE.blockOfBusiness;
        state.employer = INITIAL_STATE.employer;
        state.location = INITIAL_STATE.location;
      } else {
        if (breadCrumbType) {
          state[breadCrumbType] = INITIAL_STATE[breadCrumbType];
        }
      }
    },
    disableBreadCrumb: (state, action) => {
      if (!action.payload || action.payload?.breadCrumbType === 'all') {
        Object.keys(INITIAL_STATE).forEach((breadCrumbType) => {
          state[breadCrumbType].disabled = true;
          if (state[breadCrumbType].key === INITIAL_STATE[breadCrumbType].key) {
            state[breadCrumbType].visible = false;
          }
        });
      }
      if (action.payload) {
        const breadCrumbType = action.payload?.breadCrumbType;
        if (breadCrumbType) {
          state[breadCrumbType].disabled = true;
          if (state[breadCrumbType].key === INITIAL_STATE[breadCrumbType].key) {
            state[breadCrumbType].visible = false;
          }
        }
      }
    },
    enableBreadCrumb: (state, action) => {
      if (!action.payload || action.payload.breadCrumbType === 'all') {
        //state.blockOfBusiness.disabled = false;
        //state.employer.disabled = false;
        //state.location.true = false;
        Object.keys(INITIAL_STATE).forEach((breadCrumbType) => {
          state[breadCrumbType].disabled = false;
          state[breadCrumbType].visible = true;
        });
      }
      if (action.payload) {
        const breadCrumbType = action.payload?.breadCrumbType;
        if (breadCrumbType) {
          state[breadCrumbType].disabled = false;
          state[breadCrumbType].visible = true;
        }
      }
    },
  },
});

//Action creators are generated for each case reducer function
export const {
  setBreadCrumb,
  resetBreadCrumb,
  disableBreadCrumb,
  enableBreadCrumb,
} = breadCrumbSlice.actions;

export default breadCrumbSlice.reducer;
